import {Component, OnInit, ViewChild} from '@angular/core';
import {TelegramChannelService} from '../../_services/telegram-channel.service';
import { LineBotService } from '../../_services/line-bot.service';
import {DialogService} from 'ng2-bootstrap-modal';
import {ConfirmComponent} from '../../_common/confirm/confirm.component';
import {DataTableDirective} from 'angular-datatables';
import {AddTelegramChannelComponent} from './add-telegram-channel/add-telegram-channel.component';

@Component({
  selector: 'app-telegram-channel',
  templateUrl: './telegram-channel.component.html',
  styleUrls: ['./telegram-channel.component.css']
})
export class TelegramChannelComponent implements OnInit {

    searchWord: string;
    delayTimer: any;
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;

    //declare parameters object
    parameters: any = {};
    //declare callback object
    callback: any = {};
    typeArray : any = {
        1 : "ラインボットと該当なテレグラムチャネル",
        2 : "他のテレグラムチャネル"
    };
    lineBotAll: any[];

    constructor(
        private telegramChannelService: TelegramChannelService,
        private lineBotService: LineBotService,
        private dialogService: DialogService) {
    }

    ngOnInit() {
        let self = this;
        this.lineBotService.getLineBot().subscribe(dataLineBot => {
            self.lineBotAll = dataLineBot;
        });
        this.registerTable();
    }


    registerTable() {
        let self = this;
        this.dtOptions = {
            language: {
                emptyTable: "データが存在しません"
            },
            order: [[0, "desc"]],
            searching: false,
            lengthChange: false,
            serverSide: true,
            pageLength: 15,
            ajax: function (parameters, callback, settings) {
                parameters["search"]["value"] = self.searchWord || '';

                //assign parameters object
                self.parameters = parameters;

                //assign callback object
                self.callback = callback;

                self.telegramChannelService.gets(parameters).subscribe(result => {
                    callback({
                        draw: parameters['draw'],
                        data: result.data,
                        recordsTotal: result.data.length,
                        recordsFiltered: result.recordsTotal
                    });
                });
            },
            columns: [
                {
                    title: "Telegramチャンネル名",
                    data: "name_telegram_channel",
                    name: "name_telegram_channel",
                    className: "all text-justify"
                },

                {
                    title: "TelegramチャンネルID",
                    data: "id_telegram_channel",
                    name: "id_telegram_channel",
                    className: "text-justify"
                },
                {
                    title: "Telegramチャンネルリンク",
                    data: "link_telegram_channel",
                    name: "link_telegram_channel",
                    className: "text-justify"
                },
                {
                    title: 'Telegramチャンネルタイプ',
                    data: function (data) {
                        return self.typeArray[data.type];
                    },
                    name: 'type',
                    className: 'all text-justify',
                },
                {
                    title: "LINEボットアカウント",
                    data: "linebot_channel_name",
                    name: "linebot_channel_name",
                    className: "all text-justify"
                },
                {
                    title: "",
                    data: "btn_is_stopped",
                    width: '60px',
                    className: "all text-center",
                    orderable: false
                },
                {
                    title: "",
                    data: function (d) {
                        return `<button class="btn btn-sm btn-primary btn-edit">編集</button>`;
                    },
                    width: '60px',
                    className: "all text-center",
                    orderable: false
                },
                {
                    title: "",
                    data: function (d) {
                        return `<button class="btn btn-sm btn-danger btn-delete">削除</button>`;
                    },
                    width: '60px',
                    className: "all text-center",
                    orderable: false
                }
            ],
            rowCallback: (row: Node, data: any[] | Object, index: number) => {
                let self = this;
                $('.btn_is_stopped', row).bind('click', () => {
                    self.stop(data);
                });
                $('.btn-edit', row).bind('click', () => {
                    self.openEditTelegramChannel(data);
                });
                $('.btn-delete', row).bind('click', () => {
                    self.confirmDelete(data);
                });
                return row;
            }
        };
    }

    valuechange(newValue) {
        this.searchWord = newValue;
        this.doSearch();
    }

    doSearch() {
        let self = this;
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(function () {
            self.rerenderDataTable();
        }, 600); // Will do the ajax stuff aft
    };

    rerenderDataTable(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
        });
    }

    loadCurrentPage() {
        // get parameters and retrive result of current page
         this.telegramChannelService.gets(this.parameters).subscribe(result => {

            // use callback function
            this.callback({

                // retrive draw current
                draw: this.parameters['draw'],

                // retrive data of current page
                data: result.data,

                // retrive number records per page
                recordsTotal: result.data.length,

                // retrive total records
                recordsFiltered: result.recordsTotal
            });
        });
    }

    openModalAddTelegramChannel() {
        let self = this;
        this.dialogService.addDialog(AddTelegramChannelComponent, {
            lineBotAll: self.lineBotAll,
            titleDialog : '新規作成'
        }).subscribe((isAccess) => {
            if (isAccess) {
                this.loadCurrentPage();
            }
        });
    }

    openEditTelegramChannel(data) {
        let self = this;
        this.dialogService.addDialog(AddTelegramChannelComponent, {
            id: data.id,
            nameTelegramChannel: data.name_telegram_channel,
            idTelegramChannel: data.id_telegram_channel,
            linkTelegramChannel: data.link_telegram_channel,
            type : data.type,
            lineBotId : data.line_bot_id,
            lineBotAll: self.lineBotAll,
            titleDialog : '編集'
        }).subscribe((isAccess) => {
            if (isAccess) {
                this.loadCurrentPage();
            }
        });
    }

    confirmDelete(data) {
        this.dialogService.addDialog(ConfirmComponent, {
            title: '確認',
            message: '削除しますが、よろしいでしょうか？'
        }).subscribe((isConfirmed) => {
            if (isConfirmed) {
                this.telegramChannelService.delete(data.id).subscribe(data => {
                    this.loadCurrentPage();
                }, error => {

                });
            }
        });
    }

    stop(data) {
        this.telegramChannelService.stop(data).subscribe(data => {
            this.loadCurrentPage();
        }, error => {

        });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/telegram-channel/telegram-channel.component.ts